import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ny",
  "use": "ny-usage",
  "viewBox": "0 0 160 448",
  "content": "<symbol viewBox=\"0 0 160 448\" id=\"ny\"><path d=\"M128 312v56c0 8.75-7.25 16-16 16H48c-8.75 0-16-7.25-16-16v-56c0-8.75 7.25-16 16-16h64c8.75 0 16 7.25 16 16zm7.5-264l-7 192c-.25 8.75-7.75 16-16.5 16H48c-8.75 0-16.25-7.25-16.5-16l-7-192c-.25-8.75 6.75-16 15.5-16h80c8.75 0 15.75 7.25 15.5 16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ny.svg
// module id = L9W9
// module chunks = 1